import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetPipelinePlannedPlantationHeadersInputDto, PipelinePlannedPlantationHeaderCreateDto, PipelinePlannedPlantationHeaderDto, PipelinePlannedPlantationHeaderExcelDownloadDto, PipelinePlannedPlantationHeaderUpdateDto } from '../dtos/pipeline-planned-plantation-header/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class PipelinePlannedPlantationHeaderService {
  private restService = inject(RestService);
  apiName = 'Operational';
  

  create = (input: PipelinePlannedPlantationHeaderCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelinePlannedPlantationHeaderDto>({
      method: 'POST',
      url: '/api/operational/pipelinePlannedPlantationHeaders',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/operational/pipelinePlannedPlantationHeaders/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/operational/pipelinePlannedPlantationHeaders',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelinePlannedPlantationHeaderDto>({
      method: 'GET',
      url: `/api/operational/pipelinePlannedPlantationHeaders/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/operational/pipelinePlannedPlantationHeaders/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetPipelinePlannedPlantationHeadersInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<PipelinePlannedPlantationHeaderDto>>({
      method: 'GET',
      url: '/api/operational/pipelinePlannedPlantationHeaders',
      params: { vendorId: input.vendorId, pipelinePropertyId: input.pipelinePropertyId, pipelinePropertyName: input.pipelinePropertyName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: PipelinePlannedPlantationHeaderExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/operational/pipelinePlannedPlantationHeaders/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, vendorId: input.vendorId, pipelinePropertyId: input.pipelinePropertyId, pipelinePropertyName: input.pipelinePropertyName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelinePlannedPlantationHeaderDto[]>({
      method: 'GET',
      url: '/api/operational/pipelinePlannedPlantationHeaders/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  undoDelete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelinePlannedPlantationHeaderDto>({
      method: 'POST',
      url: `/api/operational/pipelinePlannedPlantationHeaders/${id}/undo-delete`,
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: PipelinePlannedPlantationHeaderUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelinePlannedPlantationHeaderDto>({
      method: 'PUT',
      url: `/api/operational/pipelinePlannedPlantationHeaders/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}